export default __webpack_public_path__ + "static/media/schultenumbers_standard.488fd21a.svg";